import { supertypeClass, property, Persistable, Remoteable, Supertype } from '@haventech/amorphic';
import { Everything } from '@hit/amorphic-types';
import { Address } from './Address';
import { Signer } from './Signer';
import { Person } from './Person';
import { Customer } from './Customer';
import { Party } from './Party';

@supertypeClass({ toClient: true, toServer: true })
export class Trustee extends Persistable(Remoteable(Supertype)) {
  @property({
    rule: ['required'],
    comment: 'Trustee type (Individual or Entity)',
  })
  type: string;

  @property({
    rule: ['required'],
    comment: 'Trustee Entity Name',
  })
  entityName: string;

  @property({
    comment: 'Who is the Authorized Signer?',
  })
  entityAuthorizedSigner: Signer;

  @property({
    comment: 'Trustee',
  })
  trusteePerson: Signer;

  @property({
    getType: () => Customer,
    comment: 'Link to Customer table',
  })
  customer: Customer;

  @property({
    getType: () => Party,
    comment: 'Link to Party table',
  })
  party: Party;

  constructor() {
    super();
  }

  static new(customer) {
    return new Trustee().init(customer);
  }

  init(customer) {
    this.customer = customer;

    return this;
  }

  typeTrigger() {
    const SignerClass = Signer;
    if (this.type === 'Entity') {
      this.entityAuthorizedSigner = SignerClass.new();
    } else if (this.type === 'Individual') {
      this.trusteePerson = SignerClass.new();
    }
    const ownerEntity = this.customer.application.primaryPolicy.ownerEntity;
    if (ownerEntity) {
      if (ownerEntity.certifiedDocumentSignee === 'designated') {
        ownerEntity.designatedTrusteeIndex = null;
      }
      ownerEntity.designatedTrusteeIndexTrigger();
    }
  }
}
